import React, { useState } from "react";
import { FormControlLabel, Switch } from "@mui/material";
import { useAgencyInfo } from "context/agency";

function RebillingTab({ saasdatda }) {
    const [agency] = useAgencyInfo();
    const [rangeValue, setRangeValue] = useState(saasdatda?.rebilling?.markupmargin || 1);
    const [toggleChecked, settoggleChecked] = useState(false);

    const handleRangeChange = (event) => {
        setRangeValue(event.target.value); // Update the state with the new range value
    };

    const handleToggleChange = () => {
        settoggleChecked(!toggleChecked);
    };

    function ChargeAmountCalculate(agency) {
        let charge;
        console.log('agency', agency)
        if (agency?.account_type === "public_app") {
            if (agency?.type === "free_trial") {
                charge = 0.15;
            } else {
                charge = agency?.charge_per_api ? agency?.charge_per_api : 0.01;
            }
        } else {
            charge = agency?.charge_per_api ? agency?.charge_per_api : 0.01;
        }
        return charge;
    }

    const apiCostPrice = ChargeAmountCalculate(agency);
    const markupMargin = ChargeAmountCalculate(agency) //rangeValue || 1; // Ensure we always have a value for markup
    const apiSellingPrice = `${ChargeAmountCalculate(agency)} x ${rangeValue} = ${(ChargeAmountCalculate(agency) * rangeValue).toFixed(2)}` //(apiCostPrice * markupMargin).toFixed(4);
    const profit = parseFloat((ChargeAmountCalculate(agency) * rangeValue).toFixed(4))
    //(apiCostPrice * markupMargin - apiCostPrice).toFixed(4);

    return (
        <div>
            <div
                style={{
                    borderRadius: "10px",
                    border: "1px solid rgba(229, 229, 229, 1)",
                    width: "50%",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <p className="px-5-dd text-left font-bold" style={{ width: "25%" }}>
                    AI Credit
                </p>
                <p className="px-5-dd text-left font-bold" style={{ width: "75%", textAlign: "right" }}>
                    <FormControlLabel
                        control={<Switch checked={toggleChecked} onChange={handleToggleChange} />}
                        label=""
                    />
                </p>
            </div>
            {toggleChecked && (
                <div style={{ width: "50%", margin: "10px 0px" }}>
                    <h5 className="font-15 text-black">Markup Margin</h5>
                    <p className="font-15">
                        These are margins that are billed to your clients for AI usage
                        <br />
                        <input
                            type="range"
                            min="1"
                            max="100"
                            value={rangeValue}
                            id="range2"
                            className="range-input"
                            style={{ width: "100%" }}
                            onChange={handleRangeChange}
                        />
                        {rangeValue} Times
                    </p>
                    <div className="heightmanagmable">
                        <div className="d-flex">
                            <div style={{ margin: "0px 15px 0px 0px" }}>
                                <label className="text-black">API Cost Price</label>
                                <div className="form-control-agust-gray font-16">
                                    {apiCostPrice}/API
                                </div>
                            </div>
                            <div style={{ margin: "0px 15px 0px 0px" }}>
                                <label>API Selling Price</label>
                                <div className="form-control-agust-gray font-16">
                                    {apiSellingPrice}
                                    {/* {`${apiCostPrice} x ${markupMargin} = ${apiSellingPrice}`} */}
                                </div>
                            </div>
                            <div style={{ margin: "0px 15px 0px 0px" }}>
                                <label>Profit</label>
                                <div className="form-control-agust-success font-16">
                                    {profit}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default RebillingTab;
